import { Box, MenuItem, Paper, TextField, Typography } from "@mui/material";
import RecordProducer from "modules/record/record-producer/components/RecordProducer";
import { FormLayoutData } from "modules/record/record-producer/services/formLayoutBuilder";
import { BuilderTranslate } from "./types";

export default function PreviewPanel({ tableName, viewId, layout, search, samples, sampleId, onSearch, onSample, tr }: {
    tableName: string; viewId?: string; layout: FormLayoutData; search: string;
    samples: { id: string; number_ref?: string }[]; sampleId: string;
    onSearch: (value: string) => void; onSample: (id: string) => void; tr: BuilderTranslate;
}) {
    return <Paper component="aside" sx={{ p: 1.5, minWidth: 0, maxHeight: "calc(100vh - 170px)", overflowY: "auto" }}>
        <Typography variant="h6" gutterBottom>{tr("preview", "Preview")}</Typography>
        <TextField fullWidth size="small" label={tr("search_example", "Search example record")} value={search} onChange={event => onSearch(event.target.value)} />
        <TextField select fullWidth size="small" label={tr("example", "Example record")} value={sampleId} onChange={event => onSample(event.target.value)} sx={{ mt: 1 }}>
            <MenuItem value="">{tr("empty_record", "Empty record")}</MenuItem>
            {samples.filter(item => !search || `${item.number_ref ?? item.id}`.toLowerCase().includes(search.toLowerCase())).map(item => <MenuItem key={item.id} value={item.id}>{item.number_ref ?? item.id}</MenuItem>)}
        </TextField>
        <Box sx={{ mt: 1, pointerEvents: "none" }} aria-label={tr("preview", "Preview")}><RecordProducer tableName={tableName} sysId={sampleId || undefined} previewLayout={layout} previewViewId={viewId} /></Box>
    </Paper>;
}
